import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Success(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="128"
      viewBox="0 0 160 128"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_41588_205032"
          x1="32.9282"
          x2="104.62"
          y1="16.6558"
          y2="106.015"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>
      </defs>
      <path
        d="M0.00500284 58.6145C-0.203577 46.3853 6.11609 34.3088 17.8184 31.0098C41.0424 24.4618 48.9155 40.1896 75.7258 26.763C88.5924 20.3178 100.864 20.3677 109.556 22.7437C119.291 25.4035 125.919 30.7105 131.348 37.7793C154.174 67.4918 118.485 81.0369 107.897 93.9834C102.265 100.871 96.4281 113.734 85.6038 121.136C68.6839 132.707 51.3562 128.174 37.0482 118.423C26.4106 111.174 17.3514 100.435 10.4371 88.5235C3.16483 75.998 0.132641 66.2415 0.00500284 58.6145Z"
        fill="url(#paint0_linear_41588_205032)"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.531783 0.846881 -0.846114 -0.533003 94.9473 1.47461)"
        width="8.3023"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.531783 0.846881 -0.846114 -0.533003 66.7539 115.475)"
        width="8.3023"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.775092 0.631848 -0.63073 -0.776002 49.4668 86.7031)"
        width="8.3023"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        opacity="0.3"
        rx="1"
        transform="matrix(0.27322 0.961951 -0.962344 0.271833 104.287 77.3281)"
        width="8.3023"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        opacity="0.3"
        rx="1"
        transform="matrix(0.0450388 0.998985 -0.999049 0.0435987 65.2852 38.4883)"
        width="8.3023"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        opacity="0.3"
        rx="1"
        transform="matrix(0.0450388 0.998985 -0.999049 0.0435987 50.7637 15)"
        width="8.3023"
      />
      <rect
        fill="#1A44F3"
        height="2.76661"
        opacity="0.3"
        rx="1"
        transform="matrix(0.738539 0.674211 -0.673034 0.739612 130.984 1.49609)"
        width="8.29849"
      />
      <rect
        fill="#1A44F3"
        height="2.76661"
        opacity="0.3"
        rx="1"
        transform="matrix(0.738539 0.674211 -0.673034 0.739612 24.8613 5)"
        width="8.29849"
      />
      <rect
        fill="#1A44F3"
        height="2.76661"
        opacity="0.3"
        rx="1"
        transform="matrix(0.738539 0.674211 -0.673034 0.739612 100.576 29.1348)"
        width="8.29849"
      />
      <rect
        fill="#1A44F3"
        height="2.76466"
        opacity="0.5"
        rx="1"
        transform="matrix(0.376505 0.926415 -0.925994 0.377539 81 60.9004)"
        width="8.30435"
      />
      <rect
        fill="#1A44F3"
        height="2.76825"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.934794 0.355189 -0.354197 -0.935171 83.7031 99.6426)"
        width="8.29481"
      />
      <rect
        fill="#1A44F3"
        height="2.76825"
        opacity="0.5"
        rx="1"
        transform="matrix(-0.934794 0.355189 -0.354197 -0.935171 149.648 27.3359)"
        width="8.29481"
      />
      <rect
        fill="#1A44F3"
        height="2.76825"
        opacity="0.5"
        rx="1"
        transform="matrix(-0.934794 0.355189 -0.354197 -0.935171 129.734 54.5879)"
        width="8.29481"
      />
      <rect
        fill="#1A44F3"
        height="2.76637"
        rx="1"
        transform="matrix(-0.703437 -0.710757 0.709631 -0.704573 141.307 46.1426)"
        width="5.53281"
      />
      <rect
        fill="#1A44F3"
        height="2.76637"
        rx="1"
        transform="matrix(-0.703437 -0.710757 0.709631 -0.704573 25.8926 81.8809)"
        width="5.53281"
      />
      <rect
        fill="#1A44F3"
        height="2.76841"
        opacity="0.5"
        rx="1"
        transform="matrix(-0.958139 0.286304 -0.285464 -0.958389 147.695 69.0859)"
        width="5.52873"
      />
      <rect
        fill="#1A44F3"
        height="2.76474"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.39899 0.916955 -0.916487 -0.400064 136.633 104.258)"
        width="5.53606"
      />
      <rect
        fill="#1A44F3"
        height="2.76788"
        rx="1"
        transform="matrix(-0.898683 0.438598 -0.437466 -0.899235 133.211 15.709)"
        width="5.52979"
      />
      <rect
        fill="#1A44F3"
        height="2.76788"
        rx="1"
        transform="matrix(0.139994 0.990152 -0.990328 0.138747 94.0723 39.5273)"
        width="5.52979"
      />
      <rect
        fill="#1A44F3"
        height="2.76721"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.818345 0.574727 -0.573496 -0.819208 160 117.467)"
        width="6.35084"
      />
      <rect
        fill="#1A44F3"
        height="2.76526"
        opacity="0.3"
        rx="1"
        transform="matrix(-0.516098 -0.85653 0.855798 -0.517309 26.3281 110.18)"
        width="5.53503"
      />
      <rect
        fill="#1A44F3"
        height="2.76627"
        opacity="0.5"
        rx="1"
        transform="matrix(0.688743 -0.725006 0.723802 0.690008 0 117.057)"
        width="5.53301"
      />
      <rect
        fill="#1A44F3"
        height="2.76427"
        rx="1"
        transform="matrix(-0.250023 -0.96824 0.968046 -0.250774 24.5352 124.682)"
        width="4.15275"
      />
      <rect
        fill="#1A44F3"
        height="2.76427"
        rx="1"
        transform="matrix(-0.250023 -0.96824 0.968046 -0.250774 106.039 67.7129)"
        width="4.15275"
      />
      <rect
        fill="#1A44F3"
        height="2.76427"
        rx="1"
        transform="matrix(0.540771 -0.84117 0.841589 0.540119 45.5723 115.357)"
        width="4.15275"
      />
      <rect
        fill="#1A44F3"
        height="2.7688"
        rx="1"
        transform="matrix(-0.999987 -0.005051 0.00503487 -0.999987 140.195 85.25)"
        width="5.52794"
      />
      <rect
        fill="#1A44F3"
        height="2.7688"
        rx="1"
        transform="matrix(-0.999987 -0.005051 0.00503487 -0.999987 78.416 94.9844)"
        width="5.52794"
      />
      <rect
        fill="#1A44F3"
        height="2.7667"
        opacity="0.5"
        rx="1"
        transform="matrix(-0.75036 -0.66103 0.659839 -0.751407 16.6465 58.293)"
        width="5.53216"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        rx="1"
        transform="matrix(-0.531783 0.846881 -0.846114 -0.533003 106.404 11.4902)"
        width="5.53487"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        rx="1"
        transform="matrix(-1 -8.74228e-08 0.00144152 -0.999999 54.4062 61.4629)"
        width="5.53487"
      />
      <rect
        fill="#1A44F3"
        height="2.76534"
        rx="1"
        transform="matrix(-1 -8.74228e-08 0.00144152 -0.999999 10.5352 29.7656)"
        width="5.53487"
      />
      <rect
        fill="#1A44F3"
        height="4.15305"
        opacity="0.5"
        rx="1"
        transform="matrix(0.988089 0.153882 -0.153402 0.988164 17.2969 31.0039)"
        width="8.29345"
      />
    </SvgIcon>
  )
}

export default Success
